import { render } from "./ProductPreview.vue?vue&type=template&id=0dcb72e6&scoped=true"
import script from "./ProductPreview.vue?vue&type=script&lang=js"
export * from "./ProductPreview.vue?vue&type=script&lang=js"

import "./ProductPreview.vue?vue&type=style&index=0&id=0dcb72e6&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcb72e6"]])

export default __exports__